export default {
  type: "oauth-clients",
  name: null,
  redirect: null,
  relationshipNames: [],
};
